<template>
  <section class="v-pagination">
    <el-pagination
      :background="background"
      layout="prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      :current-page.sync="currentPage"
      @current-change="currentChange"
    />
  </section>
</template>

<script>
export default {
  name: 'VPagination',
  props:{
    background: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 100
    },
    current: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  watch: {
    current: {
      immediate: true,
      handler(val) {
        if(val !== this.currentPage) {
          this.currentPage = val
        }
      }
    }
  },
  methods: {
    currentChange(page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-pagination {
  margin: 30px auto;
  text-align: center;
}
</style>